import { FC, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";

import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import { Icon } from "../../../../components/icon";
import { getDDMMYYYFormat, isDateInRange } from "../../../../helper/dateTimeHelper";

import CreateRequestButton from "../../components/CreateRequestButton";
import { AiOutlineFilter } from "react-icons/ai";
import { requestApprovalStatusHasIsDemandOptions } from "../types";
import { ExportFileExcel } from "../components";
import moment, { Moment } from "moment";
import { compareRequestStatus } from "../../utils";
import { useDemandSupplyColumns } from "./hooks/use-demand-for-supplies-column";
import { useDemandForSuppliesRequests } from "./hooks";
import { Table, UserManual } from "../../../../components";

export const procedureDemandForSupplies: FC = withProcedureWraper(() => {
  const history = useHistory();
  const { columns } = useDemandSupplyColumns();
  const {
    mappedDemandForSuppliesMyRequests,
    mappedDemandForSuppliesRequests2 = [],
    isLoading,
    guideLink,
  } = useDemandForSuppliesRequests();

  const [filters, setFilters] = useState<any>({
    createdDateTime: null,
    eRequestStatus: null,
  });

  const filteredDataSource = useMemo(() => {
    let dataSource = [...mappedDemandForSuppliesRequests2];
    if (filters.eRequestStatus) {
      dataSource = dataSource.filter((e: any) => compareRequestStatus(e.eRequestStatus, filters?.eRequestStatus!));
    }
    if (filters.createdDateTime) {
      const [startDate, endDate]: [Moment, Moment] = filters.createdDateTime;
      dataSource = dataSource.filter((e: any) => {
        const createDate = moment(e.createdDateTime);
        return isDateInRange(createDate, startDate.startOf("day"), endDate.endOf("day"));
      });
    }

    return dataSource;
  }, [filters, mappedDemandForSuppliesRequests2]);

  const flattedData = mappedDemandForSuppliesRequests2.map((record: any) => ({
    id: record.id,
    createdDateTime: getDDMMYYYFormat(record.createdDateTime),
    eRequestStatus: record.eRequestStatus,
    eRequestPersonName: record.createdByName,
    ePhoneNumber: record.ePhoneNumber,
    eDepartment: record.eDepartment,
    eUnit: record.eUnit,
    eDescription: record.eDescription,
    eRequestStatusText: requestApprovalStatusHasIsDemandOptions.find((e) => e.value === record.eRequestStatus)?.label,
  }));

  return (
    <div className="ITCodeGrantedPage">
      <div className="pd15">
        <UserManual title="NHU CẦU CẤP VẬT TƯ, CCDC CNTT" icon={<Icon.ComputerLine />} guideLink={guideLink} />

        <Box
          title="Yêu cầu của tôi "
          titleRight={
            <CreateRequestButton
              onClick={() => history.push(Routes.createDemandForSuppliesPage.path.replace(":id", "0"))}
            />
          }
        >
          <Table
            loading={isLoading}
            rowKey="id"
            columns={columns}
            scroll={{ x: 1100 }}
            dataSource={mappedDemandForSuppliesMyRequests}
            onRow={(record) => ({
              onClick: () => history.push(Routes.demandForSuppliesDetailPage.path.replace(":id", record.id)),
              style: { cursor: "pointer" },
            })}
          />
        </Box>

        <Box
          title="Các yêu cầu cần duyệt"
          titleRight={
            <ExportFileExcel
              exportContent={{
                fileName: "Danh sach yeu cau can duyet nhu cau cap vat tu CCDC CNTT",
                content: [
                  { header: "Mã yêu cầu", dataIndex: "id" },
                  { header: "Người yêu cầu", dataIndex: "eRequestPersonName" },
                  { header: "SĐT Người yêu cầu", dataIndex: "ePhoneNumber" },
                  { header: "Cơ quan/Đơn vị", dataIndex: "eDepartment" },
                  { header: "Đơn vị", dataIndex: "eUnit" },
                  { header: "Mô tả", dataIndex: "eDescription" },
                  { header: "Trạng thái", dataIndex: "eRequestStatusText" },
                ],
              }}
              data={flattedData}
              initialValues={filters}
              requestStatusOptions={requestApprovalStatusHasIsDemandOptions}
              onChange={(_, allValues: any) => setFilters(allValues)}
            >
              <div>
                <CreateRequestButton label="Bộ lọc" prefixIcon={<AiOutlineFilter />} />
              </div>
            </ExportFileExcel>
          }
        >
          <Table
            loading={isLoading}
            rowKey="id"
            columns={columns}
            scroll={{ x: 1100 }}
            dataSource={filteredDataSource}
            onRow={(record) => ({
              onClick: () => history.push(Routes.demandForSuppliesDetailPage.path.replace(":id", record.id)),
              style: { cursor: "pointer" },
            })}
          />
        </Box>
      </div>
    </div>
  );
});
